import { ApiResult } from 'interfaces/APITypes';
import { FeedbackAnswer } from 'interfaces/FeedbackTypes';

import { UserFeedbackFormData } from 'components/feedback/UserFeedback';

import { makeRequest, mytoverInstance } from './client';

export const getFeedback = async (options?: any): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get('/feedback', { params: options }));
};

export const postFeedback = async (payload: UserFeedbackFormData | FeedbackAnswer): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.post('/feedback', payload));
};

export const getFeedbackQuestions = async (event?: string): Promise<ApiResult> => {
  return makeRequest(mytoverInstance.get(`/feedback/questions/${event}`));
};
